module.exports = __webpack_public_path__ + "static/media/front.eaa2fc67.jpg";